<p>report-product-tos works!</p>
